import React from 'react';
import { Field, FieldRenderProps, useForm, FieldProps } from 'react-final-form';
import AutoSave from '../AutoSave';
import TextInput from '../../../components/Inputs/Text/TextMin';
import { IndicatorStateOptions } from '../../../components/Indicator';
// FIXME making custom props optional until this is resolved:
// https://github.com/final-form/react-final-form/issues/175
type TextInputMetaProps = {
  invalid?: boolean;
  error?: string;
  initial?: any;
  disabled?: boolean;
  submitting?: boolean;
  submitFailed?: boolean;
  submitSucceeded?: boolean;
  dirtySinceLastSubmit?: boolean;
  dirty?: boolean;
};

const getIndicatorState = (
  props: TextInputMetaProps,
): IndicatorStateOptions => {
  let state: IndicatorStateOptions = 'new';
  if (props.initial) state = 'complete';
  if (props.error || props.invalid) state = 'error';
  if (props.submitting && props.dirtySinceLastSubmit !== props.dirty)
    state = 'loading';
  return state;
};

interface TextInputFieldComponentProps
  extends FieldRenderProps<any, HTMLInputElement> {
  text?: string;
  informationText?: string[];
  enabled?: boolean;
  supportingLink?: React.MouseEventHandler;
  handleSubmit?: () => void;
}

const TextInputFieldComponent = ({
  input,
  meta,
  handleSubmit,
  enabled,
  ...rest
}: TextInputFieldComponentProps) => {
  return (
    <AutoSave
      name={input.name}
      handleSubmit={handleSubmit ? handleSubmit : () => {}}>
      <TextInput
        {...input}
        {...meta}
        enabled={enabled}
        // disabled={meta.submitting}
        indicatorState={getIndicatorState(meta)}
        {...rest}
      />
    </AutoSave>
  );
};

export interface TextInputFieldProps
  extends FieldProps<any, FieldRenderProps<any>> {
  text?: string;
  informationText?: string[];
  supportingLink?: React.MouseEventHandler;
  enabled?: boolean;
}

const TextField = (props: TextInputFieldProps) => {
  const form = useForm();
  const required = !(props.enabled === false) && props.required;
  return (
    <Field
      component={TextInputFieldComponent}
      handleSubmit={form.submit}
      {...props}
      required={required}
      validate={required ? props.validate : undefined}
    />
  );
};

export default TextField;
